// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-scjtRlsbxxcx-index-main_right_content-2Hjru","table":"components-tjcx-scjtRlsbxxcx-index-table-3ZPLx"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/scjtRlsbxxcx/index.css
// module id = 2313
// module chunks = 0